import React, { useState } from 'react';
import Footer from './Footer';
import Main from './Main';

export default function Home(props) {
  return (
    <>
      <Main />
      <Footer />
    </>
  );
}
